import styled from 'styled-components';
import { palette, Theme } from '@dev/ee-components';
import { StyledProps } from '../AddInterface';

export const ScreenWrapper = styled.div`
    input {
        padding: 0;
        border: 0; //prevent 2018 styles
    }
    & .MuiAlert-root {
        margin-bottom: 24px;
        color: ${palette.gray[7]};
    }
    & .MuiRadio-root {
        padding: 2px 9px;
    }
`;

export const InputContainer = styled.div`
    display: inline-block;
    width: calc(33% - 24px);
    ${Theme.breakpoints.down('sm')} {
        width: 100%;
    }
    box-sizing: border-box;
    // margin-top: 1.2rem;
    ${Theme.breakpoints.down('sm')} {
        margin-top: 1rem;
    }
    & > div > div:first-of-type,
    & > div > div:first-of-type > div,
    & .MuiButton-contained {
        width: 100%;
    }
    & + & {
        margin-left: 24px;
        ${Theme.breakpoints.down('sm')} {
            margin-left: 0;
        }
    }
    .MuiAutocomplete-root {
        .MuiAutocomplete-popupIndicator {
            margin-right: 5px;
            margin-top: 2px;
        }
    }
`;

export const ContactFormSection = styled.div`
    border-top: 1px solid ${palette.gray[3]};
`;

export const AddContactForm = styled.form<StyledProps>`
    .numberItem {
        color: ${palette.jacarta[5]};
        font: Bold 16px/24px Nunito;
        letter-spacing: 0px;
        width: 32px;
        height: 32px;
        border-radius: 32px;
        background: #ffffff 0% 0% no-repeat padding-box;
        box-shadow: 0px 1px 3px #67679dcc;
        opacity: 1;
        margin-right: ${({ isMobile }) => (isMobile ? '24px' : '32px')};
        display: inline-block;
        line-height: 32px;
        text-align: center;
    }
    h2 {
        padding-bottom: ${({ isMobile }) => (isMobile ? '0' : '28px')};
        font: Bold 19px/34px Nunito;
        letter-spacing: 0px;
        font-weight: 800;
        color: ${palette.jacarta[5]};
        text-transform: none;
        margin: ${({ isMobile }) => isMobile && '4px 0 12px'};
    }
    ${({ isMobile }): string => `
    & > div:first-child {
        border-top: ${isMobile ? 'none' : `1px solid ${palette.gray[3]}`};
        padding-top: ${isMobile ? '36px' : '32px'};
    }
    & > div {
        display: ${isMobile ? `flex` : 'block'};
        flex-direction: ${isMobile && `column`};
        padding: ${isMobile ? '27px 0 32px' : '32px 0'};
    }
    `}
`;

export const FooterContainer = styled.div<StyledProps>`
    display: flex;
    padding: ${({ isMobile }) => (isMobile ? '16px 20px 0' : '32px 48px 0')};
    border-top: 1px solid ${palette.gray[3]};
    align-items: center;
    justify-content: flex-end;
    .MuiFormControlLabel-root {
        margin-bottom: 0;
    }
`;

export const StyledMobile = styled.div<StyledProps>`
    ${({ isMobile }): string => `
    .MuiAlert-standardInfo {
        display: ${isMobile ? 'none' : 'flex'};
    }
    .styledPaper {
        padding-top: ${isMobile ? '0' : '34px'};
        padding-bottom: ${isMobile ? '16px' : '34px'};

        .paperStyles {
            padding: ${isMobile ? '0 24px' : '0 48px'}
        }
    }
    .permissionsSection {
        & > div {
            margin-top: ${isMobile ? '18px' : '0'};
        }
    }
    .permissionRadioGroup {
        & > div:first-child {
            margin-bottom: ${isMobile ? '16px' : '0'};
        } 
    }
    .MuiFormControlLabel-label {
        width: ${isMobile ? 'max-content' : '100%'}
    }
    `}
`;
